import classNames from "classnames";
import _uniqueId from 'lodash/uniqueId';
import { useRef, useState } from "react";
import ReactTooltip, { Effect, Place } from "react-tooltip";
import styles from "./Tooltip.module.css"

export type TooltipProps = {
  children: any
  tooltipHtml: any
  place?: Place
  effect?: Effect
  className?: string
  tooltipClassName?: string
}

export default function Tooltip({ children, className, tooltipClassName, place = "top", effect = "solid", tooltipHtml, ...props }: TooltipProps) {
  const btnRef = useRef();
  const [id] = useState(_uniqueId('tooltip-'));

  let tooltipStyle = styles.tooltipTop
  switch (place) {
    case "top":
      tooltipStyle = styles.tooltipTop
      break;
    case "right":
      tooltipStyle = styles.tooltipRight
      break;
    case "left":
      tooltipStyle = styles.tooltipLeft
      break;
  }

  return (
    <>
      <div data-tip data-for={id} ref={btnRef} className={className}>
        {children}
      </div>

      <ReactTooltip
        id={id}
        place={place}
        effect={effect}
        multiline={true}
        className={classNames(styles.tooltip, tooltipStyle)}
      >
        <div className={tooltipClassName}>
          {tooltipHtml}
        </div>
      </ReactTooltip>
    </>
  )
}